import React from "react";
import "./MultiStepProgressBar.css";
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import { Row } from "react-bootstrap";

const MultiStepProgressBar = props => {
  var stepPercentage = 0;

  if (props.currentStep === 1) {
    stepPercentage = 50;
  } else if (props.currentStep === 2) {
    stepPercentage = 100;
  } else {
    stepPercentage = 0;
  }

  return (
    <ProgressBar percent={stepPercentage}>
      <Step>
        {({ accomplished, index }) => (
          <Row
            className={`indexedStep ${accomplished ? "accomplished" : null}`}
          >
            {index + 1}
          </Row>
        )}
      </Step>
      <Step>
        {({ accomplished, index }) => (
          <Row
            className={`indexedStep ${accomplished ? "accomplished" : null}`}
          >
            {index + 1}
          </Row>
        )}
      </Step>
    </ProgressBar>
  );
};

export default MultiStepProgressBar;
